import React from 'react';
const font = '"Nunito Sans", system-ui, sans-serif';

/** Top-down group room, drawn with the pack's symbol legend. */
export function RoomDiagram({
  className = ''
}: {
  className?: string;
}) {
  const cx = 150;
  const cy = 160;
  const R = 92;
  const seats = [{
    a: -90,
    t: 'stand'
  }, {
    a: -45,
    t: 'stand'
  }, {
    a: 0,
    t: 'seat'
  }, {
    a: 45,
    t: 'stand'
  }, {
    a: 90,
    t: 'wheel'
  }, {
    a: 135,
    t: 'stand'
  }, {
    a: 180,
    t: 'seat'
  }, {
    a: 225,
    t: 'stand'
  }];
  return <svg viewBox="0 0 300 300" role="img" aria-label="Top-down room diagram: group circle with facilitator, standing, seated and wheelchair participants, an observer zone and a movement path" className={`h-auto w-full ${className}`} data-id="element-279" data-mp="2j0y1bctrvnht">
      <defs data-id="element-280" data-mp="292ialaynqg8u">
        <marker id="room-arrow" viewBox="0 0 10 10" refX="8" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse" data-id="element-281" data-mp="2931sirob54mv">
          <path d="M0 0 L10 5 L0 10 z" fill="#3F8A9C" data-id="element-282" data-mp="xo4r0iaxsmym" />
        </marker>
      </defs>
      <rect x="8" y="8" width="284" height="284" rx="14" fill="#F7F2E8" data-id="element-283" data-mp="xqhfzff43xl6" />
      {/* Observer zone */}
      <rect x="214" y="18" width="68" height="54" rx="10" fill="#86B09A" fillOpacity="0.25" data-id="element-284" data-mp="31qhp97eyjzp9" />
      <rect x="238" y="38" width="20" height="14" rx="3" fill="#86B09A" data-id="element-285" data-mp="36p2op4mdyfcn" />
      <text x="248" y="66" textAnchor="middle" fontSize="8.5" fontWeight="800" fill="#5C8C74" fontFamily={font} data-id="element-286" data-mp="2rtmn8ejh7h68">OBSERVE</text>

      <circle cx={cx} cy={cy} r={R} fill="none" stroke="#1E2D5C" strokeWidth="2" data-id="element-287" data-mp="2wv2cyjwlmbuy" />
      <path d="M96 214 Q 140 110 214 130" fill="none" stroke="#3F8A9C" strokeWidth="2.2" strokeDasharray="3 6" strokeLinecap="round" data-id="element-288" data-mp="2j0jcwf44nkft" />
      <path d="M118 120 Q 150 96 182 120" fill="none" stroke="#3F8A9C" strokeWidth="2.4" markerEnd="url(#room-arrow)" data-id="element-289" data-mp="293wxw6yhfnlp" />

      {seats.map(({
      a,
      t
    }) => {
      const r = a * Math.PI / 180;
      const x = cx + Math.cos(r) * R;
      const y = cy + Math.sin(r) * R;
      if (t === 'seat') return <g key={a} data-id="element-290" data-mp="244tqifv155ak">
              <rect x={x - 11} y={y - 2} width="22" height="14" rx="3" fill="#86B09A" data-id="element-291" data-mp="24426816vutzl" />
              <circle cx={x} cy={y - 5} r="9" fill="#FFFDF9" stroke="#1E2D5C" strokeWidth="2" data-id="element-292" data-mp="ammpp5lkbgnb" />
            </g>;
      if (t === 'wheel') return <g key={a} data-id="element-293" data-mp="viac4rz5try">
              <circle cx={x} cy={y} r="10" fill="#FFFDF9" stroke="#1E2D5C" strokeWidth="2" data-id="element-294" data-mp="x34htadnapa" />
              <circle cx={x + 11} cy={y + 9} r="7" fill="none" stroke="#6B8FBF" strokeWidth="2.4" data-id="element-295" data-mp="3s3e0hb0j5l9r" />
            </g>;
      return <circle key={a} cx={x} cy={y} r="10" fill="#FFFDF9" stroke="#1E2D5C" strokeWidth="2" data-id="element-296" data-mp="tjxn0knmw004" />;
    })}

      {/* Facilitator star */}
      <circle cx={cx} cy={cy} r="16" fill="#EBC06A" data-id="element-297" data-mp="jmjagw4tzvd3" />
      <text x={cx} y={cy + 5} textAnchor="middle" fontSize="14" fontWeight="800" fill="#1E2D5C" fontFamily={font} data-id="element-298" data-mp="jkyb8t7kno8w">F</text>
    </svg>;
}